export default {"src":"/_next/static/media/typhon.5f0c9a27.svg","height":162,"width":223,"blurWidth":0,"blurHeight":0};